import { createAction } from '@reduxjs/toolkit';
import {
  ADD_PAYMENT_METHOD,
  CANCEL_SCHEDULED_TRANSFER,
  REFUND_VOPAY_PAYMENT,
  CLEAR_PAYMENT_DATA,
  CLEAR_USER_PAYMENT_DATA,
  CREATE_RESIDENT_VOPAY_ACCOUNT,
  FUND_TRANSFER_WITHDRAW,
  FUND_TRANSFER_WITHDRAW_SCHEDULE,
  GET_BUILDING_ONBOARDING_STATUS,
  GET_VOPAY_USER,
  GET_VOPAY_USER_PAYMENT_METHODS,
  GET_ORGANIZATION_ONBOARDING_STATUS,
  SYNC_PAYMENT_METHOD,
  UPDATE_PAYMENT_DATA,
  GET_BUILDING_PAYMENT_STATS
} from '../constants';

export const getOrganizationOnboardingStatus = createAction(GET_ORGANIZATION_ONBOARDING_STATUS);
export const getBuildingOnboardingStatus = createAction(GET_BUILDING_ONBOARDING_STATUS);

export const getBuildingPaymentStats = createAction(GET_BUILDING_PAYMENT_STATS);
export const getVopayUser = createAction(GET_VOPAY_USER);
export const getVopayUserPaymentMethods = createAction(GET_VOPAY_USER_PAYMENT_METHODS);
export const addPaymentMethod = createAction(ADD_PAYMENT_METHOD);
export const createResidentVopayAccount = createAction(CREATE_RESIDENT_VOPAY_ACCOUNT);
export const syncPaymentMethod = createAction(SYNC_PAYMENT_METHOD);

export const updatePaymentData = createAction(UPDATE_PAYMENT_DATA);
export const clearPaymentData = createAction(CLEAR_PAYMENT_DATA);
export const resetPaymentUserData = createAction(CLEAR_USER_PAYMENT_DATA);

export const fundTransferWithdrawRequest = createAction(FUND_TRANSFER_WITHDRAW);
export const fundTransferWithdrawScheduleRequest = createAction(FUND_TRANSFER_WITHDRAW_SCHEDULE);
export const cancelScheduledTransfer = createAction(CANCEL_SCHEDULED_TRANSFER);
export const refundVopayPayment = createAction(REFUND_VOPAY_PAYMENT);
